
const token = "eyJhbGciOiJSUzI1NiJ9.eyJhdWQiOiJhdGcsIGRvY2hhbmRsaW5nLCBkeW5hZm9ybSwgbGVnYWN5cHJlcGFpZHJlZywgb25lY2FyZSwgb25lc2hvcCwgcG9ydGFsLCBwcmVwYWlkcmVnLCBxdWlja2FjdCwgdGVsZWtvbWZpb2ssIHVuaXZscCwgd29wIiwic3ViIjoiL3Byb2ZpbGVzLzE2OTE0ODY3IiwibmJmIjowLCJpc3MiOiJodHRwczovL3RlbGVrb20uaHUvb2lkYyIsImV4cCI6MTY4NjAwNTUwMiwidHdvX2ZhIjpmYWxzZSwiaWF0IjoxNjg2MDAzNzYyLCJkZXZpY2VJZCI6Ik1vemlsbGEvNS4wIChXaW5kb3dzIE5UIDEwLjA7IFdpbjY0OyB4NjQpIEFwcGxlV2ViS2l0LzUzNy4zNiAoS0hUTUwsIGxpa2UgR2Vja28pIENocm9tZS8xMTIuMC4wLjAgU2FmYXJpLzUzNy4zNiIsImp0aSI6ImRlODNiN2JjLTc1ZGItNDVkZC1hNGUxLTE5MDg5MGRiZWFiZiJ9.caSJDvl_ffO97Iqg_f7RZ_3-izXaf0K9F5Z0g7FC0wXYqBQekPo0iLS5t3l7vmfUCV6-elHf0dj-HMV8csY737SIP6G5qpAFO5tz3wSiyTWUuu4deZ7OyFw3V3sgzt-wIPp8BYvbgZtNGyukODe_gpJK9qbf_tC27Ptx9gdNByg5mX1Y6UEQ5Hms2Q5Icpm3EJ6gSlbcvbTHyz9Q58fAHbbAy6hVrWkG69XNmnAMCa0lJ1z2MxvVfFtG2oX9SPAuItzK2nNeu0U74eD10fWed71vASP--BQ2C-FxbFbTT1RHjrstDTk2QqMuH_1135QBC2G1Vsms1pCf0SmDz_AZFg"
const backEndURL = process.env.NODE_ENV === "development" ? "http://localhost:8001/uzleti/ugyintezes/jogosultsag-valasztas/api" : "/uzleti/ugyintezes/jogosultsag-valasztas/api";
export function getListAPI() {
    return new Promise((resolve) => {
        var myHeaders = new Headers();
        myHeaders.append("Accept", "application/json");
        myHeaders.append("Cookie", "mt-op-session-token=eyJhbGciOiJSUzI1NiJ9.eyJhdWQiOiJhdGcsIGRvY2hhbmRsaW5nLCBkeW5hZm9ybSwgbGVnYWN5cHJlcGFpZHJlZywgb25lY2FyZSwgb25lc2hvcCwgcG9ydGFsLCBwcmVwYWlkcmVnLCBxdWlja2FjdCwgdGVsZWtvbWZpb2ssIHVuaXZscCwgd29wIiwic3ViIjoiL3Byb2ZpbGVzLzE2OTE0ODY3IiwibmJmIjowLCJpc3MiOiJodHRwczovL3RlbGVrb20uaHUvb2lkYyIsImV4cCI6MTY4NjAwNTUwMiwidHdvX2ZhIjpmYWxzZSwiaWF0IjoxNjg2MDAzNzYyLCJkZXZpY2VJZCI6Ik1vemlsbGEvNS4wIChXaW5kb3dzIE5UIDEwLjA7IFdpbjY0OyB4NjQpIEFwcGxlV2ViS2l0LzUzNy4zNiAoS0hUTUwsIGxpa2UgR2Vja28pIENocm9tZS8xMTIuMC4wLjAgU2FmYXJpLzUzNy4zNiIsImp0aSI6ImRlODNiN2JjLTc1ZGItNDVkZC1hNGUxLTE5MDg5MGRiZWFiZiJ9.caSJDvl_ffO97Iqg_f7RZ_3-izXaf0K9F5Z0g7FC0wXYqBQekPo0iLS5t3l7vmfUCV6-elHf0dj-HMV8csY737SIP6G5qpAFO5tz3wSiyTWUuu4deZ7OyFw3V3sgzt-wIPp8BYvbgZtNGyukODe_gpJK9qbf_tC27Ptx9gdNByg5mX1Y6UEQ5Hms2Q5Icpm3EJ6gSlbcvbTHyz9Q58fAHbbAy6hVrWkG69XNmnAMCa0lJ1z2MxvVfFtG2oX9SPAuItzK2nNeu0U74eD10fWed71vASP--BQ2C-FxbFbTT1RHjrstDTk2QqMuH_1135QBC2G1Vsms1pCf0SmDz_AZFg; iPlanetDirectoryPro=REACT_APP_I_PLANET_DIRECTORY_PRO");
        //response.headers.append('set-cookie', value);
        var requestOptions = {
            method: 'GET',
            redirect: 'follow',
            headers: myHeaders
        };
        fetch(backEndURL + "/page/", requestOptions)

            .then(response => response.json())
            .then(data => resolve({ data: data }))
            .catch(error => {
                resolve({ error: [] });
                alert("Hiba történt! Vegye fel a kapcsolatot az ügyfélszolgálattal!")
            });
    });
}

export function getProfileListAPI(profileId) {
    return new Promise((resolve) => {
        var myHeaders = new Headers();
        myHeaders.append("Accept", "application/json");
        myHeaders.append("Cookie", "mt-op-session-token=eyJhbGciOiJSUzI1NiJ9.eyJhdWQiOiJhdGcsIGRvY2hhbmRsaW5nLCBkeW5hZm9ybSwgbGVnYWN5cHJlcGFpZHJlZywgb25lY2FyZSwgb25lc2hvcCwgcG9ydGFsLCBwcmVwYWlkcmVnLCBxdWlja2FjdCwgdGVsZWtvbWZpb2ssIHVuaXZscCwgd29wIiwic3ViIjoiL3Byb2ZpbGVzLzE2OTE0ODY3IiwibmJmIjowLCJpc3MiOiJodHRwczovL3RlbGVrb20uaHUvb2lkYyIsImV4cCI6MTY4NjAwNTUwMiwidHdvX2ZhIjpmYWxzZSwiaWF0IjoxNjg2MDAzNzYyLCJkZXZpY2VJZCI6Ik1vemlsbGEvNS4wIChXaW5kb3dzIE5UIDEwLjA7IFdpbjY0OyB4NjQpIEFwcGxlV2ViS2l0LzUzNy4zNiAoS0hUTUwsIGxpa2UgR2Vja28pIENocm9tZS8xMTIuMC4wLjAgU2FmYXJpLzUzNy4zNiIsImp0aSI6ImRlODNiN2JjLTc1ZGItNDVkZC1hNGUxLTE5MDg5MGRiZWFiZiJ9.caSJDvl_ffO97Iqg_f7RZ_3-izXaf0K9F5Z0g7FC0wXYqBQekPo0iLS5t3l7vmfUCV6-elHf0dj-HMV8csY737SIP6G5qpAFO5tz3wSiyTWUuu4deZ7OyFw3V3sgzt-wIPp8BYvbgZtNGyukODe_gpJK9qbf_tC27Ptx9gdNByg5mX1Y6UEQ5Hms2Q5Icpm3EJ6gSlbcvbTHyz9Q58fAHbbAy6hVrWkG69XNmnAMCa0lJ1z2MxvVfFtG2oX9SPAuItzK2nNeu0U74eD10fWed71vASP--BQ2C-FxbFbTT1RHjrstDTk2QqMuH_1135QBC2G1Vsms1pCf0SmDz_AZFg; iPlanetDirectoryPro=REACT_APP_I_PLANET_DIRECTORY_PRO");
        var requestOptions = {
            method: 'GET',
            redirect: 'follow',
            headers: myHeaders
        };
        fetch(backEndURL + "/page?customerId=" + profileId, requestOptions)
            .then(response => response.json())
            .then(data => resolve({ data: data }))
            .catch(error => {
                resolve({ error: [] });
                alert("Hiba történt! Vegye fel a kapcsolatot az ügyfélszolgálattal!")
            });
    });
}

export function getCustomerListAPI(customerId) {
    return new Promise((resolve) => {
        var myHeaders = new Headers();
        myHeaders.append("Accept", "application/json");
        myHeaders.append("Cookie", "mt-op-session-token=eyJhbGciOiJSUzI1NiJ9.eyJhdWQiOiJhdGcsIGRvY2hhbmRsaW5nLCBkeW5hZm9ybSwgbGVnYWN5cHJlcGFpZHJlZywgb25lY2FyZSwgb25lc2hvcCwgcG9ydGFsLCBwcmVwYWlkcmVnLCBxdWlja2FjdCwgdGVsZWtvbWZpb2ssIHVuaXZscCwgd29wIiwic3ViIjoiL3Byb2ZpbGVzLzE2OTE0ODY3IiwibmJmIjowLCJpc3MiOiJodHRwczovL3RlbGVrb20uaHUvb2lkYyIsImV4cCI6MTY4NjAwNTUwMiwidHdvX2ZhIjpmYWxzZSwiaWF0IjoxNjg2MDAzNzYyLCJkZXZpY2VJZCI6Ik1vemlsbGEvNS4wIChXaW5kb3dzIE5UIDEwLjA7IFdpbjY0OyB4NjQpIEFwcGxlV2ViS2l0LzUzNy4zNiAoS0hUTUwsIGxpa2UgR2Vja28pIENocm9tZS8xMTIuMC4wLjAgU2FmYXJpLzUzNy4zNiIsImp0aSI6ImRlODNiN2JjLTc1ZGItNDVkZC1hNGUxLTE5MDg5MGRiZWFiZiJ9.caSJDvl_ffO97Iqg_f7RZ_3-izXaf0K9F5Z0g7FC0wXYqBQekPo0iLS5t3l7vmfUCV6-elHf0dj-HMV8csY737SIP6G5qpAFO5tz3wSiyTWUuu4deZ7OyFw3V3sgzt-wIPp8BYvbgZtNGyukODe_gpJK9qbf_tC27Ptx9gdNByg5mX1Y6UEQ5Hms2Q5Icpm3EJ6gSlbcvbTHyz9Q58fAHbbAy6hVrWkG69XNmnAMCa0lJ1z2MxvVfFtG2oX9SPAuItzK2nNeu0U74eD10fWed71vASP--BQ2C-FxbFbTT1RHjrstDTk2QqMuH_1135QBC2G1Vsms1pCf0SmDz_AZFg; iPlanetDirectoryPro=REACT_APP_I_PLANET_DIRECTORY_PRO");
        var requestOptions = {
            method: 'GET',
            redirect: 'follow',
            headers: myHeaders
        };
        fetch(backEndURL + "/page?customerId=" + customerId, requestOptions)
            .then(response => response.json())
            .then(data => resolve({ data: data }))
            .catch(error => {
                resolve({ error: [] });
                alert("Hiba történt! Vegye fel a kapcsolatot az ügyfélszolgálattal!")
            });
    });
}

/*export function getPage(queryParams) {
    return new Promise((resolve) => {
        var requestOptions = {
            method: 'GET',
            redirect: 'follow',
        };
        fetch(backEndURL + "/page" + queryParams, requestOptions)
            .then(response => response.json())
            .then(data => {
                if (data.errorDTO === null || data.errorDTO === undefined) {
                    if (data.redirectUrl !== undefined) {
                        window.location.replace(data.redirectUrl)
                    }
                }
                resolve({ data: data })
            })
            .catch((error, response) => {
                resolve({ error: error });
            });
    });
}*/

export function getPage(queryParams, timeout = 40000) {
    return new Promise((resolve, reject) => {
        const controller = new AbortController();
        const timeoutId = setTimeout(() => {
            controller.abort();
            reject(new Error('Request timed out'));
        }, timeout);

        var requestOptions = {
            method: 'GET',
            redirect: 'follow',
            signal: controller.signal,
        };

        fetch(backEndURL + "/page" + queryParams, requestOptions)
            .then(response => response.json())
            .then(data => {
                clearTimeout(timeoutId);
                if (data.errorDTO === null || data.errorDTO === undefined) {
                    if (data.redirectUrl !== undefined) {
                        window.location.replace(data.redirectUrl);
                    }
                }
                resolve({ data: data });
            })
            .catch(error => {
                clearTimeout(timeoutId);
                reject(new Error(error));
            });
    });
}


export function selectUserAPI(queryParams, timeout = 40000) {
    return new Promise((resolve, reject) => {
        const controller = new AbortController();
        const timeoutId = setTimeout(() => {
            controller.abort();
            reject(new Error('Request timed out'));
        }, timeout);

        var requestOptions = {
            method: 'GET',
            redirect: 'follow',
            signal: controller.signal,
        };

        fetch(backEndURL + "/select-user" + queryParams, requestOptions)
            .then(response => response.json())
            .then(data => {
                clearTimeout(timeoutId);
                if (data.errorDTO === null || data.errorDTO === undefined) {
                    if (data.redirectUrl !== undefined) {
                        window.location.replace(data.redirectUrl)
                    }
                }
                resolve({data: data})
            })
            .catch(error => {
                clearTimeout(timeoutId);
                reject(new Error(error));
            });
    });
}
// export function selectUserAPI(queryParams) {
//     return new Promise((resolve) => {
//         var myHeaders = new Headers();
//         var requestOptions = {
//             method: 'GET',
//             redirect: 'follow'
//         };
//         fetch(backEndURL + "/select-user" + queryParams, requestOptions)
//             .then(response => response.json())
//             .then(data => {
//                 if (data.errorDTO === null || data.errorDTO === undefined) {
//                     if (data.redirectUrl !== undefined) {
//                         window.location.replace(data.redirectUrl)
//                     }
//                 }
//
//                 resolve({data: data})
//             })
//             //.then(result => window.location.replace(result.redirectUrl))
//             .catch(error => console.log('error', error));
//     });
// }

export function errorRedirectAPI(queryParams) {
    return new Promise((resolve) => {
        var requestOptions = {
            method: 'GET',
            redirect: 'follow'
        };
        fetch(backEndURL + "/error-redirect" + queryParams, requestOptions)
            .then(response => response.json())
            .then(result => window.location.replace(result.redirectUrl))
            .catch(error => console.log('error', error));
    });
}
